var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessResetPw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "120px",
    viewBox: "0 0 119 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Message/Success Reset PW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 86.31 0 86.31 119.9997 0 119.9997"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Message/Success-Reset-PW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.621,101.2812 C35.995,101.2812 35.39,101.0462 34.927,100.6192 L21.124,87.8952 C20.108,86.9602 20.044,85.3782 20.98,84.3632 C21.916,83.3472 23.498,83.2832 24.513,84.2192 L36.414,95.1902 L67.026,59.6302 C67.928,58.5822 69.508,58.4672 70.552,59.3662 C71.599,60.2672 71.717,61.8452 70.815,62.8912 L38.516,100.4122 C38.073,100.9262 37.441,101.2382 36.765,101.2772 C36.717,101.2802 36.669,101.2812 36.621,101.2812",
    id: "Fill-1",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.327,44.0117 L61.327,35.7687 C61.327,25.7487 53.175,17.5967 43.155,17.5967 C33.136,17.5967 24.983,25.7487 24.983,35.7687 L24.983,44.0117 L13.726,44.0117 L13.726,34.4287 C13.726,18.2017 26.929,4.9997 43.155,4.9997 C59.382,4.9997 72.584,18.2017 72.584,34.4287 L72.584,44.0117 L61.327,44.0117 Z M56.327,44.0117 L29.983,44.0117 L29.983,35.7687 C29.983,28.5057 35.892,22.5967 43.155,22.5967 C50.418,22.5967 56.327,28.5057 56.327,35.7687 L56.327,44.0117 Z M77.584,44.9127 L77.584,34.4287 C77.584,15.4447 62.139,-0.0003 43.155,-0.0003 C24.171,-0.0003 8.726,15.4447 8.726,34.4287 L8.726,44.9127 C3.633,46.8597 0,51.7847 0,57.5537 L0,82.0057 C0,83.3867 1.119,84.5057 2.5,84.5057 C3.881,84.5057 5,83.3867 5,82.0057 L5,57.5537 C5,52.8437 8.832,49.0117 13.543,49.0117 L27.483,49.0117 L58.827,49.0117 L72.767,49.0117 C77.478,49.0117 81.31,52.8437 81.31,57.5537 L81.31,106.4577 C81.31,111.1677 77.478,114.9997 72.767,114.9997 L13.543,114.9997 C8.832,114.9997 5,111.1677 5,106.4577 L5,98.7817 C5,97.4007 3.881,96.2817 2.5,96.2817 C1.119,96.2817 0,97.4007 0,98.7817 L0,106.4577 C0,113.9247 6.075,119.9997 13.543,119.9997 L72.767,119.9997 C80.235,119.9997 86.31,113.9247 86.31,106.4577 L86.31,57.5537 C86.31,51.7847 82.677,46.8597 77.584,44.9127 L77.584,44.9127 Z",
    id: "Fill-3",
    fill: "#000000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessResetPw);
export default __webpack_public_path__ + "static/media/success_reset_pw.f9e6de04d8fe63e20ce90b1d55eac61b.svg";
export { ForwardRef as ReactComponent };